function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconAmenitiesWashingMachineFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.717 4.005v23.998h22.565V4.005H4.717zm-.19-2h22.946c1 0 1.81.827 1.81 1.848v24.302c0 1.02-.81 1.848-1.81 1.848H4.526c-.999 0-1.809-.828-1.809-1.848V3.853c0-1.02.81-1.848 1.81-1.848z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 23.947c2.904 0 5.322-2.408 5.322-5.457 0-3.05-2.418-5.458-5.322-5.458-2.905 0-5.322 2.408-5.322 5.457 0 3.05 2.417 5.458 5.322 5.458zm7.322-5.457c0 4.118-3.278 7.457-7.322 7.457-4.044 0-7.322-3.339-7.322-7.457 0-4.12 3.278-7.458 7.322-7.458 4.044 0 7.322 3.339 7.322 7.457z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 20.585c1.081 0 2.02-.904 2.02-2.096 0-1.193-.939-2.096-2.02-2.096-1.083 0-2.022.903-2.022 2.096 0 1.192.94 2.096 2.021 2.096zm4.02-2.096c0 2.262-1.8 4.096-4.02 4.096-2.222 0-4.022-1.834-4.022-4.096 0-2.263 1.8-4.096 4.021-4.096s4.021 1.833 4.021 4.096zM27.304 9.065H4.15v-2h23.153v2zM24.952 6.013h-1.96v-1h1.96v1zM22.018 6.013h-1.96v-1h1.96v1z",
    fill: props.color
  }));
}

export default SvgIconAmenitiesWashingMachineFilled;